module.exports = __webpack_public_path__ + "img/kxlogo.c87ff71e.png";